import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import logoFicheLab from "src/core/assets/images/logo-fiche-lab.png";

const OPACITY = 0.5;

const styles = StyleSheet.create({
  header: {
    position: "absolute",
    top: 0,
    left: 24,
    right: 24,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 16,
    paddingBottom: 8,
  },
  leftSpacer: {
    width: 86,
    flexGrow: 0,
    flexShrink: 0,
  },
  logoWrapper: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    opacity: OPACITY,
  },
  logo: {
    width: 86,
    height: 20,
  },
  confidentialWrapper: {
    width: 100,
    flexGrow: 0,
    flexShrink: 0,
    alignItems: "flex-end",
  },
  confidential: {
    fontSize: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    opacity: OPACITY,
    color: "#0A1A53",
    letterSpacing: 1.4,
  },
});

export const PdfHeader = () => {
  const { t } = useTranslation();

  return (
    <View style={styles.header} fixed>
      <View style={styles.leftSpacer} />
      <View style={styles.logoWrapper}>
        <Image src={logoFicheLab} style={styles.logo} />
      </View>
      <View style={styles.confidentialWrapper}>
        <Text style={styles.confidential} wrap={false}>
          {t("pdf.header.confidential")}
        </Text>
      </View>
    </View>
  );
};
